export default function formatNumber(phone: string) {
  if (!phone) return null;

  const formattedPhone = phone.replace(/[^\d]/g, '');

  return formattedPhone.length === 10
    ? formattedPhone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
    : phone;
}
